import { PipelineState, PipelineResult } from './types';
import type { GetThemeVersions, TriggerThemeDeploy, GetPipelineStatus } from './types';

// Contract-shaped canned data so the UI can build against real types before the backend is
// reachable. The mock -> real swap is a one-line change in index.ts. Optional fields are omitted
// (never null), matching the frozen contract.

const MOCK_PIPELINE_UUID = '{11111111-1111-1111-1111-111111111111}';

export const getThemeVersions: GetThemeVersions = async _partnerCode => ({
  latest: 'v1.916.0',
  regenPreview: 'v1.915.0',
  regen: 'v1.914.0',
  updatedAt: '2026-07-16T12:00:00Z',
});

// A just-triggered run: in progress, no result yet (result omitted, not null).
export const triggerThemeDeploy: TriggerThemeDeploy = async (_partnerCode, _selector) => ({
  uuid: MOCK_PIPELINE_UUID,
  buildNumber: 1234,
  state: PipelineState.InProgress,
});

// A terminal, successful run.
export const getPipelineStatus: GetPipelineStatus = async (_partnerCode, uuid) => ({
  uuid,
  buildNumber: 1234,
  state: PipelineState.Completed,
  result: PipelineResult.Successful,
});
